import * as Common from './common';
if ('wakeLock' in navigator) {
    // Function that attempts to request a screen wake lock.
    const requestWakeLock = async () => {
        try {           
            wakeLock = await navigator.wakeLock.request();
            document.querySelector('#vislock i').classList.add('text-success');
            document.querySelector('#vislock i').classList.remove('fa-lock-open');
            document.querySelector('#vislock i').classList.add('fa-lock');
            if ( Common.getCookie('wakelock') !== 1 ) {
                Common.setCookie('wakelock', 1, 1);
            }
            wakeLock.addEventListener('release', () => {
                console.log('Screen Wake Lock released:', wakeLock.released);              
            });            
        } catch (err) {
            console.error(`${err.name}, ${err.message}`);
        }
    };
    
    const handleVisibilityChange = () => {
        if (wakeLock !== null && document.visibilityState === 'visible') {
            requestWakeLock();
        }
    };

    const toggleWakeLock = () => {
        if (wakeLock !== null && document.visibilityState === 'visible') {
            wakeLock.release();
            wakeLock = null;
            document.querySelector('#vislock i').classList.remove('text-success');            
            document.querySelector('#vislock i').classList.remove('fa-lock');
            document.querySelector('#vislock i').classList.add('fa-lock-open');
            if ( Common.getCookie('wakelock') == 1 ) {
                Common.setCookie('wakelock', 0, 1);
            }
        } else {
            requestWakeLock();
        }
    };


    // Screen Wake Lock API supported 🎉
    let wakeLock = null;

    // Check if wakelock active    
    if ( Common.getCookie('wakelock') == 1 ) {
        console.log('wakelock active');
        requestWakeLock();
    }    

    if (document.getElementById('vislock')) {
        document.getElementById('vislock').addEventListener('click', toggleWakeLock);
    }

}
